import { Injectable } from '@angular/core';
import { Observable, Subject, of, BehaviorSubject } from "rxjs";
import { AppConfigService } from 'src/app/services/app-config.service';
import { ApiService } from "./api.service";
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class OperationsService {

  baseUrl: string = this.appConfig.configuration.environment.endPoints.operationServices;
  lausdAvailable$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  lastUpdate$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  constructor(
    private appConfig: AppConfigService,
    private api: ApiService
  ) { }


  getLastUpdate() {
    const path = `${this.baseUrl}/v1/data-sync/lastUpdate`;
    return this.api.get(path).pipe(map((response) => response as any));
  }
  getLastCacheUpdate(username,source) {
    const path = `${this.baseUrl}/v1/data-sync/lastCacheUpdate?username=${username}&source=${source}`;
    return this.api.get(path).pipe(map((response) => response as any));
  }
  sendFeedback(model) {
    const path = `${this.baseUrl}/v1/lausd/feedback`;
    return this.api.post(path,model).pipe(map((response) => response as any));
  }
}
